import {css, cx} from "@panda/css";

import {SelectRangeFieldControlled} from "@pg-design/rhf-components-module";
import {SelectRangeVariant} from "@pg-design/select-range-module";

import {ROOM_SELECTOR_OPTIONS} from "./constants/room_selector_options";

interface IProps {
    colorVariant?: "primary" | "secondary";
    dataTestId?: string;
    name: string;
    transparentBackground?: boolean;
    variant?: SelectRangeVariant;
}

export const RoomSelector = (props: IProps) => {
    const {colorVariant = "primary", dataTestId, name, transparentBackground = false, variant} = props;

    return (
        <div className={containerStyle} data-testid={dataTestId}>
            <SelectRangeFieldControlled
                className={cx(
                    selectRangeStyle,
                    colorVariant === "secondary" && selectRangeSecondaryStyle,
                    transparentBackground && selectRangeTransparentStyle
                )}
                name={name}
                options={ROOM_SELECTOR_OPTIONS}
                variant={variant}
            />
        </div>
    );
};

const containerStyle = css({
    display: "flex",
    flexDirection: "column",
    gap: 2
});

const selectRangeStyle = css({
    "--select-border-color": "var(--colors-gray-600)"
});

const selectRangeSecondaryStyle = css({
    "--select-active-color": "var(--colors-secondary)",
    "--select-active-text-color": "var(--colors-white)",
    "--select-non-active-color": "var(--colors-secondary)",
    "--select-non-active-text-color": "var(--colors-white)"
});

const selectRangeTransparentStyle = css({
    "--select-default-color": "transparent"
});
import {css, cx} from "@panda/css";

import {SelectRangeFieldControlled} from "@pg-design/rhf-components-module";
import {SelectRangeVariant} from "@pg-design/select-range-module";

import {ROOM_SELECTOR_OPTIONS} from "./constants/room_selector_options";

interface IProps {
    colorVariant?: "primary" | "secondary";
    dataTestId?: string;
    name: string;
    transparentBackground?: boolean;
    variant?: SelectRangeVariant;
}

export const RoomSelector = (props: IProps) => {
    const {colorVariant = "primary", dataTestId, name, transparentBackground = false, variant} = props;

    return (
        <div className={containerStyle} data-testid={dataTestId}>
            <SelectRangeFieldControlled
                className={cx(
                    selectRangeStyle,
                    colorVariant === "secondary" && selectRangeSecondaryStyle,
                    transparentBackground && selectRangeTransparentStyle
                )}
                name={name}
                options={ROOM_SELECTOR_OPTIONS}
                variant={variant}
            />
        </div>
    );
};

const containerStyle = css({
    display: "flex",
    flexDirection: "column",
    gap: 2
});

const selectRangeStyle = css({
    "--select-border-color": "var(--colors-gray-600)"
});

const selectRangeSecondaryStyle = css({
    "--select-active-color": "var(--colors-secondary)",
    "--select-active-text-color": "var(--colors-white)",
    "--select-non-active-color": "var(--colors-secondary)",
    "--select-non-active-text-color": "var(--colors-white)"
});

const selectRangeTransparentStyle = css({
    "--select-default-color": "transparent"
});
